import React, { useEffect } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import S from './Solution.module.css';

import { tagHeaderData, tagBodytData } from './SolutionData';
import { tag1, tag2, tag3, tag4, tag5, tag6, tag7, tag8, arrow } from '../../assets/images/solution/solutionImages';
import BasicTable from '../../components/Table/BasicTable';
import { Link } from 'react-router-dom';

const TagPage = () => {
  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="solution" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="solution" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div className={isMobile() ? 'mb-50' : 'mb-80'}>
            <img src={tag1} alt='tag1' className={`${S.solContentImg} mt-30`} />
          </div>
          <div className='mb-50'>
            <div className={S.textLineDiv}></div>
            <div className={S.titleText}>
              900Mhz TAG 인코딩 솔루션
            </div>
            <div className={`${S.smallContentText} mt-20`}>
              900Mhz 등록기를 통해 900Mhz EPC Data를 Write 할 수 있는 프로그램 입니다.<br />
              엑셀 업로드를 통해 대량의 태그를 손쉽게 인코딩 할 수 있습니다.
            </div>
            <img src={tag2} alt='tag2' className={`${S.solContentImg} mt-20 mr-20`}/>
            <img src={tag3} alt='tag3' className={`${S.solContentImg} mt-20`}/>
          </div>

          <div className='mb-50'>
            <div className={S.textLineDiv}></div>
            <div className={S.titleText}>
              900Mhz 등록기 사양
            </div>
            <div className={S.rfImgBtnDiv}>
              <img src={tag4} alt='tag4' id={S.tagImg4}/> 
              <div className={S.rdImgBtnLink}>
                <Link to={'https://www.rfemfo.co.kr/product/detail?idx=114&list=1'} target='_blank' className='text-line-none'>
                  <div draggable className={`${S.downFileDiv} ${S.tagFileDiv}`}>
                    <div>
                      900Mhz 등록기 보러가기
                    </div>
                    <img src={arrow} alt='arrow'/>
                  </div>
                </Link>
              </div> 
            </div>
            <div className='mt-50'>
              <BasicTable headers={tagHeaderData} items={tagBodytData} />
            </div>
          </div>

          <div className='mb-50'>
            <div className={S.textLineDiv}></div>
            <div className={S.titleText}>
              900Mhz TAG 인코딩 솔루션의 기능
            </div>
            <img src={tag5} alt='tag5' className={`${S.solContentImg} mt-50`}/>
            <div className={`${S.contentText} mt-50`}>
              <div className={S.introText}>
                1.등록기 연결 설정 : 인식률(RF파워) 및 태그 인식간격 조정<br />
                2. 인코딩 작업결과 : 발급대상 data 및 인코딩 성공/실패 유무 확인 가능<br />
                3. 상태창 : 안테나 수신 (태그 인식 / 미 인식) 로그 확인<br />
                * 파워값은 10~30dBm<br />
                * 파워, 발행간격은 리더기 연결 후 수정 불가
              </div>
            </div>
            <img src={tag6} alt='tag6' className={`${S.solContentImg} mt-50`}/>
            <div className={`${S.contentText} mt-50`}>
              <div className={S.introText}>
                엑셀 양식에 맞게 EPC Data 입력 후 엑셀등록<br />
                업로드된 Data 및 length 확인가능
              </div>
            </div>
            <img src={tag7} alt='tag7' className={`${S.solContentImg} mt-50`}/>
            <div className={`${S.contentText} mt-50`}>
              <div className={S.introText}>
                EPC Data 입력 에러 시 오류 선수 표시<br />
                EPC Data 최소 단위는 16bit, 16진수 4자리 입니다.
              </div>
            </div>
            <img src={tag8} alt='tag8' className={`${S.solContentImg} mt-50`}/>
            <div className={`${S.contentText} mt-50`}>
              <div className={S.introText}>성공 표시 후 순차 태그 인식하여 발행</div>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default TagPage;
